import API from '@/api/api'

export default {
  // eslint-disable-next-line
  LOGIN_USER ({}, data) {
    return API.POST.auth.login(data)
  },
  // eslint-disable-next-line
  SEND_PASSWORD_RESET ({}, data) {
    return API.POST.auth.pwdReset(data)
  },
  // eslint-disable-next-line
  GET_RECOVERY ({}, recoveryId) {
    return API.GET.auth.pwdReset(recoveryId)
  },
  // eslint-disable-next-line
  RESET_PASSWORD ({}, data) {
    return API.POST.auth.recoverPwd(data)
  }
}
